import JourneyManaged from './component';
export default JourneyManaged;
